/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./model-upload-specification.vue?vue&type=template&id=51a31a6a&scoped=true&"
import script from "./model-upload-specification.vue?vue&type=script&lang=ts&"
export * from "./model-upload-specification.vue?vue&type=script&lang=ts&"
import style0 from "./model-upload-specification.vue?vue&type=style&index=0&id=51a31a6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a31a6a",
  null
  
)

export default component.exports